var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TenantControllerApiFactory } from "@/apis/tenant-management";
import { LocalStorageKeys } from "@/constants/localStorage";
import useApi from "@/hooks/useApi";
import { Select } from "@atom/ui-kit";
import { upperCase } from "lodash";
import React from "react";
import { Container } from "./TenantSelect.style";
var TenantSelect = function (props) {
    var _a;
    var _b = useApi({
        asyncFunction: TenantControllerApiFactory().tenantsGet,
    }), callTenantManagementList = _b.call, tenantManagementData = _b.data, tenantManagementLoading = _b.loading;
    React.useEffect(function () {
        callTenantManagementList();
    }, []);
    return (_jsx(Container, { isTransparent: props.isTransparent, children: _jsx(Select, __assign({ defaultValue: localStorage.getItem(LocalStorageKeys.TENANT), style: { width: "100%" }, loading: tenantManagementLoading }, props, { children: (_a = tenantManagementData === null || tenantManagementData === void 0 ? void 0 : tenantManagementData.data) === null || _a === void 0 ? void 0 : _a.tenants.map(function (tenant) { return (_jsx(Select.Option, { value: tenant.name, children: upperCase(tenant.name) }, tenant.name)); }) })) }));
};
export default TenantSelect;
